import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import {
  fetchLinkedTracks,
  setLinkedPage,
  setTab,
} from 'features/crux/tracker/list/trackerListSlice'
import Table from 'components/table/Table'
import Pagination from 'components/pagination/Pagination'
import HelpTooltip from 'components/tooltip/HelpTooltip'
import LinkedTrackItem from 'features/crux/tracker/list/linked/LinkedTrackItem'
import { showCreateTrackModal } from 'features/crux/tracker/modal/create/createTrackSlice'

const LinkedTracks = () => {
  const dispatch = useDispatch()
  const {
    linkedContent,
    linkedPage,
    linkedTotalElements,
    linkedLoading,
    linkedLoadingError,
  } = useSelector(state => state.tracker.trackerList)
  useEffect(() => {
    dispatch(fetchLinkedTracks())
  }, [dispatch, linkedPage])
  return (
    <>
      <div className="managebox_tit">
        <p className="desc_box">
          광고계정에 연동되어 있는 픽셀 &amp; SDK 목록으로, 최대 100개까지
          사용할 수 있습니다.
        </p>
      </div>
      <div className="tblg2_wrap">
        <Table
          className="tbl_g2 tbl_event"
          caption="픽셀 & SDK 전체 표"
          loading={!!linkedLoading}
          error={!!linkedLoadingError}
          errorMessage={
            <>
              일시적인 문제로 픽셀 & SDK를 불러올 수 없습니다.
              <br />
              페이지를{' '}
              <NoneAnchor
                className="link_txt"
                onClick={() => {
                  dispatch(fetchLinkedTracks())
                }}>
                새로고침
              </NoneAnchor>{' '}
              하세요.
            </>
          }
          emptyMessage={
            <>
              연동중인 픽셀 &amp; SDK가 없습니다.
              <br />
              <NoneAnchor
                className="link_txt"
                onClick={() => dispatch(showCreateTrackModal())}>
                픽셀 &amp; SDK 만들기
              </NoneAnchor>
              하거나,
              <NoneAnchor
                className="link_txt"
                onClick={() => dispatch(setTab('unlinked'))}>
                연동 가능한 픽셀 &amp; SDK 목록
              </NoneAnchor>
              에서 ‘연동하기’버튼을 클릭하세요.
            </>
          }>
          <Table.Head>
            <Table.Column title="연동 일시" width={145} />
            <Table.Column title="픽셀 & SDK (ID)" />
            <Table.Column
              width={340}
              title={
                <>
                  연동 서비스
                  <HelpTooltip>
                    픽셀 & SDK에 연동된 서비스입니다.
                    <br />
                    마우스오버하면 상세 서비스를 확인할 수 있습니다.
                  </HelpTooltip>
                </>
              }
            />
            <Table.Column
              width={105}
              title={
                <>
                  모수
                  <HelpTooltip>
                    이벤트별로 최근 180일간 수집한 추정 모수입니다.
                  </HelpTooltip>
                </>
              }
            />
            <Table.Column
              width={140}
              title={
                <>
                  이벤트 수집현황
                  <HelpTooltip>
                    픽셀 & SDK로 이벤트가 수집되고 있는 상태입니다.
                    <br />
                    픽셀 & SDK를 설치하거나 서비스를 연동하면 이벤트가
                    수집됩니다.
                  </HelpTooltip>
                </>
              }
            />
            <Table.Column width={108} title="광고계정 연동" />
          </Table.Head>
          <Table.Body>
            {linkedContent.map(data => (
              <Table.Row key={data.trackId}>
                <LinkedTrackItem data={data} />
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {linkedTotalElements > 0 && (
        <div className="paging_wrap">
          <div className="inner_paging">
            <Pagination
              current={linkedPage}
              total={linkedTotalElements}
              onChange={newPage => dispatch(setLinkedPage(newPage))}
            />
          </div>
        </div>
      )}
    </>
  )
}
export default LinkedTracks
